export const contacto = {
  telefono: '+1 (786) 224-1575',
  telefonoHref: 'tel:+17862241575',
  whatsapp: '+1 (613) 942-5150',
  whatsappHref: 'https://wa.me/16139425150',
  email: 'contacto@magiapoderosa.com',
  direccion: ['Botánica Magia Poderosa', '1450 SW 8th St, Suite 3', 'Miami, FL 33135'],
}

export const imagenes = {
  hero: 'https://cdn.magicpatterns.com/patterns/generated-images/b7236b68-6f16-4866-8ca5-b625b288b362.jpg',
  rayosRojos: 'https://cdn.magicpatterns.com/patterns/generated-images/f6241ed5-3605-4e67-9baa-b28372d512ca.jpg',
  altarRojo: 'https://cdn.magicpatterns.com/patterns/generated-images/a126f559-01e0-44fd-9d83-73d5f67d0cf1.jpg',
  arcoPiedra: 'https://cdn.magicpatterns.com/patterns/generated-images/26c4f044-0fca-4d91-bc05-9f853c850201.jpg',
  tarotBlanco: 'https://cdn.magicpatterns.com/patterns/generated-images/4e9e9774-1532-4ff6-8647-afa5e5ffd103.jpg',
  negraFondo: 'https://cdn.magicpatterns.com/patterns/generated-images/18d00d7f-b625-4975-b540-a24043d74b23.jpg',
  santaMuerte: 'https://cdn.magicpatterns.com/patterns/generated-images/cc3b93cb-7e3d-4546-bb7b-147d197f8a08.jpg',
  fachada: 'https://cdn.magicpatterns.com/patterns/generated-images/7bba7b20-9b73-461f-bcba-fc52530735a1.jpg',
}
